/**
 * eslint-disable no-undef
 *
 * @format
 */

import { reduce } from 'lodash';
import { invert } from 'lodash';
import { paths } from './paths';

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID
};

export const mapboxConfig = {
  apiKey: process.env.REACT_APP_MAPBOX_API_KEY
};

export const apiPointPublic = ['login', 'checkPhoneNumberExist'];
export const errorMessageCode = {
  invalid_verification_code: 'auth/invalid-verification-code',
  too_many_requests: 'auth/too-many-requests'
};
export const googleApiScopeRequest = {
  readPhoneNumber: 'https://www.googleapis.com/auth/user.phonenumbers.read'
};

export const valueContants = {
  password_overtime_reset: 60
};

export const refreshKeyConfig = {
  pageReload: 'page-reload',
  pageLoading: 'page-loading',
  carBrandList: 'car-brand-list',
  carModelList: 'car-model-list',
  carList: 'car-list',
  carScheduleList: 'car-schedule-list',
  baseFeeList: 'base-fee-lis',
  userList: 'car-list',
  nxOverview: 'nhaxe-overview',
  nixFindCar: 'nhieuxe-find-car'
};

export const casueServerErrors = {
  tokenExpired: 'auth/access-token-expired'
};

export const listPageConfig = {
  rowPerpage: 25,
  rowsPerPageOptions: [5, 10, 25, 30, 35, 40, 50, 100]
};

export const carSeats = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 24, 25, 26, 27, 28, 29, 30, 35, 45];
export const carTransmissions = { automatic: 'Số sàn', manual: 'Tự động' };
export const carFuelTypes = { gasoline: 'Xăng', diesel: 'Dầu Diesel', electric: 'Điện' };
export const carYearOfManufactureStart = 2005;
export const defineRoles = [
  {
    key: 'isGuest',
    value: 0,
    text: 'Guest'
  },
  {
    key: 'isViewer',
    value: 2,
    text: 'Viewer'
  },
  {
    key: 'isNhaXe',
    value: 4,
    text: 'Mod'
  },
  {
    key: 'isNhieuXe',
    value: 6,
    text: 'Admin'
  },
  {
    key: 'isOwner',
    value: 10,
    text: 'Owner'
  }
];

export const bookingScheduleStatus = {
  unconfirmed: 'UNCONFIRMED',
  confirmed: 'CONFIRMED',
  departed: 'DEPARTED',
  pickedUp: 'PICKED_UP',
  onRoute: 'ON_ROUTE',
  droppedOff: 'DROPPED_OFF',
  returned: 'RETURNED',
  notTracking: 'NOT_TRACKING'
};

export const bookingScheduleType = {
  selfBooking: 'SELF_BOOKING', // Nhà xe tự tạo booking
  partnerBooking: 'PARTNER_BOOKING', // Được gửi qua từ một bên khác (trung gian)
  customerBooking: 'CUSTOMER_BOOKING' // Khách hàng trực tiếp đặt
};

export const permissionList = {
  access: {
    quickSettingMenu: 'quick_setting__menu',
    managementOverviewMenu: 'management__overview__menu',
    managementAnalyticMenu: 'management__analytic__menu',
    managementScheduleMenu: 'management__schedule__menu',
    managementCarMenu: 'management__car__menu',
    managementCarBtnAdd: 'management__car__btn_add',
    managementCarBtnEdit: 'management__car__btn_edit',
    managementCarBtnDelete: 'management__car__btn_delete',
    managementCarBtnActive: 'management__car__btn_active',
    bookingMenu: 'booking__menu',
    bookingMenuTab: 'booking__menu_tab',
    bookingMenuTabAdd: 'booking__menu_tab_add',
    bookingMenuTabEdit: 'booking__menu_tab_edit',
    bookingMenuTabPin: 'booking__menu_tab_pin',
    bookingMenuTabManagement: 'booking__menu_tab_management',
    bookingMenuCheckAvailableCar: 'booking__menu_check_available_car',
    bookingMenuCheckRoute: 'booking__menu_check_route',
    bookingIndex: 'booking__index',
    configurationMenu: 'configuration__menu',
    configurationMenuSub: 'configuration__menu_sub',

    configurationCostBasicMenu: 'configuration__cost_basic__menu',
    configurationCostBasicBtnAdd: 'configuration__cost_basic__btn_add',
    configurationCostBasicBtnEdit: 'configuration__cost_basic__btn_edit',
    configurationCostBasicBtnDelete: 'configuration__cost_basic__btn_delete',
    configurationCostBasiBtnActive: 'configuration__cost_basic__btn_active',

    configurationCarBrandMenu: 'configuration__car_banrd__menu',
    configurationCarBrandBtnAdd: 'configuration__car_banrd__btn_add',
    configurationCarBrandBtnEdit: 'configuration__car_banrd__btn_edit',
    configurationCarBrandBtnDelete: 'configuration__car_banrd__btn_delete',
    configurationCarBrandBtnActive: 'configuration__car_banrd__btn_active',

    configurationCarModelMenu: 'configuration__car_model__menu',
    configurationCarModelBtnAdd: 'configuration__car_model__btn_add',
    configurationCarModelBtnEdit: 'configuration__car_model__btn_edit',
    configurationCarModelBtnDelete: 'configuration__car_model__btn_delete',
    configurationCarModelBtnActive: 'configuration__car_model__btn_active',

    userMenu: 'user__menu',
    userBtnAdd: 'user__btn_add',
    userBtnEdit: 'user__btn_edit',
    userBtnDelete: 'user__btn_delete',
    userBtnActive: 'user__btn_active',
    userApiGetAll: 'user__api_get_all'
  },
  control: {
    managementOverviewIndex: 'management__overview__index',
    managementAnalyticIndex: 'management__analytic__index',
    managementScheduleIndex: 'management__schedule__index',
    managementCarIndex: 'management__car__index',
    managementCarEditBaseFee: 'management__car__edit_base_fee',
    bookingIndex: 'booking__index',
    configurationCostBasicIndex: 'configuration__cost_basic__index',
    configurationCarBrandIndex: 'configuration__car_banrd__index',
    configurationCarModelIndex: 'configuration__car_model__index',
    userIndex: 'user__index'
  }
};

export const configSettings = {
  petrol_price: {
    valueType: 'number',
    type: 'currency',
    key: 'petrol_price',
    value: 0,
    endAdornment: '₫'
  },
  vat_percent: {
    valueType: 'float',
    type: 'number',
    key: 'vat_percent',
    value: 8,
    endAdornment: '%'
  },
  vat_flag: {
    valueType: 'boolean',
    type: 'flag',
    key: 'vat_flag',
    value: false
  },
  twoway: {
    valueType: 'boolean',
    type: 'flag',
    key: 'twoway',
    value: false
  },
  driver_self_suff: {
    valueType: 'boolean',
    type: 'flag',
    key: 'driver_self_suff',
    value: false
  }
};
export const lableSettings = {
  petrol_price: 'Giá dầu',
  vat_percent: 'Thuế VAT',
  vat_flag: '+Thuế VAT',
  twoway: '+Hai chiều',
  driver_self_suff: '+Tài xế tự túc'
};

export const userKeyValueRoles = reduce(
  defineRoles,
  (result, { key, value }) => {
    result[key] = value;
    return result;
  },
  {}
);

export const userValueTextRoles = reduce(
  defineRoles,
  (result, { value, text }) => {
    result[value] = text;
    return result;
  },
  {}
);

// ## remove
export const userOptionRoles = {
  0: {
    key: 'isOwner',
    text: 'Quản lý',
    value: 0
  },
  2: {
    key: 'isNhieuXe',
    text: 'Nhiều xe',
    value: 2
  },
  4: {
    key: 'isNhaXe',
    text: 'Nhà xe',
    value: 4
  },
  6: {
    key: 'isViewer',
    text: 'Thành viên',
    value: 6
  },
  8: {
    key: 'isGuest',
    text: 'Vô danh',
    value: 8
  }
};

export const userRoles = {
  owner: 0,
  nhieu_xe: 2,
  nha_xe: 4,
  viewer: 6,
  guest: 8
};

export const docEmbedConfig = {
  nodes: {
    customers: ['name', 'number_device', 'is_enable', 'customer_id']
  },
  parameters: {
    inputs: [
      'id',
      'name',
      'type',
      'index',
      'threshold',
      'modbus',
      'active_time',
      'scaling_factor',
      'time_to_live',
      'is_enable',
      'is_active',
      'device_id',
      'updated_at',
      'created_at'
    ],
    outputs: ['id', 'name', 'type', 'index', 'modbus', 'is_enable', 'is_active', 'device_id', 'updated_at', 'created_at']
  }
};

export const messasgeConfig = {
  requested_data_not_found: 'The requested data was not found.',
  limit_recod: 'Insert limit reached. Review and remove unnecessary entries.'
};
export const optionsConfig = {
  inputType: {
    1: 'Digital',
    2: 'Analog',
    3: 'Temperature',
    4: 'Voltage',
    5: 'Current',
    6: 'Frequency',
    7: 'Power',
    8: 'Power factor',
    9: 'Pressure',
    10: 'Level',
    11: 'Speed',
    12: 'State',
    13: 'Time',
    14: 'Count',
    15: 'Percent'
  },
  outputType: {
    1: 'Button',
    2: 'Relay'
  },
  activeTimeLoop: {
    1: 'Monday',
    2: 'Tuesday',
    4: 'Wednesday',
    8: 'Thursday',
    16: 'Friday',
    32: 'Saturday',
    64: 'Sunday',
    256: 'All day'
  }
};

export const dashboardLoadType = {
  report: 'report',
  realtime: 'realtime'
};
export const exceptInputTypeDiagnostic = ['Digital', 'Analog'];
export const mqttDefautConfig = {
  clean: true,
  connectTimeout: 10000,
  username: '',
  setCleanSession: true,
  reconnectPeriod: 30000
};
export const mqttTopics = {
  device: 'device'
};

export const mqttObjects = {
  user: 1 << 0,
  project: 1 << 1,
  device: 1 << 2,
  sensor: 1 << 3,
  actuator: 1 << 4,
  config: 1 << 5,
  scheduall: 1 << 6,
  firmware: 1 << 7
};

export const mqttActions = {
  create: 1 << 0,
  update: 1 << 1,
  delete: 1 << 2,
  control: 1 << 3,
  read: 1 << 4,
  write: 1 << 5,
  scan: 1 << 6,
  active: 1 << 7,
  unActive: 1 << 8,
  loaded: 1 << 9,
  watched: 1 << 10,
  realtime: 1 << 11
};
export const outputIndexButton = {
  stop: 1,
  auto: 2,
  manual: 3,
  test: 4,
  start: 5,
  unload: 6,
  load: 7,
  mute: 8
};

export const outputIndexButtonType = invert(outputIndexButton);

export const prefixLoginType = '##WEB##';

export const changeDeviceActionType = {
  stop: {
    on: { type: 1, index: outputIndexButton.stop },
    off: [
      { type: 1, index: outputIndexButton.auto },
      { type: 1, index: outputIndexButton.manual },
      { type: 1, index: outputIndexButton.test },
      { type: 1, index: outputIndexButton.start },
      { type: 1, index: outputIndexButton.mute },
      { type: 1, index: outputIndexButton.load },
      { type: 1, index: outputIndexButton.unload }
    ]
  },
  start: {
    on: { type: 1, index: outputIndexButton.start },
    off: [
      { type: 1, index: outputIndexButton.stop },
      { type: 1, index: outputIndexButton.test }
    ]
  },

  auto: {
    on: { type: 1, index: outputIndexButton.auto },
    off: [
      { type: 1, index: outputIndexButton.stop },
      { type: 1, index: outputIndexButton.manual },
      { type: 1, index: outputIndexButton.test },
      { type: 1, index: outputIndexButton.start }
    ]
  },
  manual: {
    on: { type: 1, index: outputIndexButton.manual },
    off: [
      { type: 1, index: outputIndexButton.stop },
      { type: 1, index: outputIndexButton.auto },
      { type: 1, index: outputIndexButton.test },
      { type: 1, index: outputIndexButton.start }
    ]
  },

  unload: {
    on: { type: 1, index: outputIndexButton.unload },
    off: [
      { type: 1, index: outputIndexButton.stop },
      { type: 1, index: outputIndexButton.load }
    ]
  },
  load: {
    on: { type: 1, index: 7 },
    off: [
      { type: 1, index: outputIndexButton.stop },
      { type: 1, index: outputIndexButton.unload }
    ]
  },

  test: {
    on: { type: 1, index: 4 },
    off: [
      { type: 1, index: outputIndexButton.stop },
      { type: 1, index: outputIndexButton.start }
    ]
  },
  mute: { on: { type: 1, index: outputIndexButton.mute } },

  unloadAvailable: { on: { type: 12, index: 1 } },
  loadAvailable: { on: { type: 12, index: 2 } },
  unloadBreaker: { on: { type: 12, index: 3 } },
  loadBreaker: { on: { type: 12, index: 4 } }
};

export const serverErrorCodeConfig = {
  permissionDenied: 'permission-denied'
};
export const typePushNotification = {
  info: 0,
  reload: 1,
  logout: 9
};
export const scheduleFlgExecute = {
  waiting: 0,
  running: 1,
  finished: 2,
  error: 3
};
export const scheduleColor = {
  expired: 'rgb(255, 244, 229)',
  error: 'rgb(253, 237, 237)',
  running: 'rgb(237, 247, 237)',
  finished: 'rgb(229, 246, 253)'
};
export const chartTypeConfig = {
  number: 'Number Chart',
  circular: 'Circular Chart',
  pie: 'Pie Chart',
  solid: 'Solid Chart',
  meter: 'Meter Chart',
  line: 'Line Chart',
  column: 'Column Chart',
  mix: 'Mix Chart'
};
export const chartOptionConfig = {
  circular: { minH: 9, minW: 10 },
  solid: { minH: 9, minW: 10 },
  meter: { minH: 9, minW: 10 },
  pie: { minH: 9, minW: 10 },
  line: { minH: 9, minW: 10 },
  column: { minH: 9, minW: 10 },
  mix: { minH: 9, minW: 10 },
  number: { minH: 3, minW: 10 }
};

export const fieldItemsCheckDirty = ['w', 'h', 'x', 'y'];
export const maxPointConfig = [5, 10, 15, 20, 25, 30];

export const alarmLevel = {
  normal: 0,
  warning: 1,
  error: 2
};

export const carStates = {
  all: 'all',
  available: 'available',
  ontour: 'ontour',
  unavailable: 'unavailable',
  scheduele: 'scheduele'
};

export const provderIds = {
  phone: 'phone',
  google: 'google.com'
};

export const scheduleLevel = 3;
export const emailActionLabels = {
  [alarmLevel.error]: 'Error',
  [alarmLevel.warning]: 'Warning',
  [scheduleLevel]: 'Schedule'
};

export const regExpPattern = {
  phoneNumber:
    /^(\+?84|0)?[-. ]?(87|9[0-8]|35|37|70|77|83|88|89|120|121|122|126|123|124|125|127|128|129|162|163|164|165|166|167|168|169|186|188|199|91|94|96|97|98|195|196|197|198|199)[-.\s]?\d{7}$/
};
export const diagnosticStatus = {
  failed: 0,
  processing: 1,
  success: 2
};
export const alarmLevelOption = invert(alarmLevel);
// export const userLabelRoles = {
//   isOwner: "Owner",
//   isAdmin: "Administrator",
//   isOperator: "Operator",
//   isViewer: "Viewer",
// };

export const pageAccessRoles = {
  [paths.management.user.index]: permissionList.access.userMenu,
  [paths.configuration.basicCost]: permissionList.access.configurationCostBasicMenu,
  [paths.configuration.carBrand]: permissionList.access.configurationCarBrandMenu,
  [paths.configuration.carModel]: permissionList.access.configurationCarModelMenu,
  [paths.booking.list]: permissionList.access.bookingMenu
};

export const socketEvents = {
  emit: {
    client_request_car: 'client_request_car',
    client_request_tour: 'client_request_tour'
  },
  on: {
    push_notification: 'push_notification',
    server_request_car: 'server_request_car',
    server_response_car: 'server_response_car',
    server_response_tour: 'server_response_tour'
  }
};

export const notificationChanel = {
  push: '/push-notifications'
};
export const pushNotificationsType = {
  bookingRequest: 'BOOKING_REQUEST',
  notice: 'NOTICE',
  refetch: 'REFETCH',
  noticeRefetch: 'NOTICE_REFETCH'
};

export const notificationActions = {
  BOOKING_REQUEST_NEW: 'BOOKING_REQUEST_NEW',
  BOOKING_REQUEST_WAITING_APPROVAL: 'BOOKING_REQUEST_WAITING_APPROVAL',
  BOOKING_REQUEST_DISMISS: 'BOOKING_REQUEST_DISMISS',
  BOOKING_REQUEST_ACCEPTED: 'BOOKING_REQUEST_ACCEPTED',
  BOOKING_REQUEST_ASSIGNED: 'BOOKING_REQUEST_ASSIGNED',
  BOOKING_REQUEST_REJECTED: 'BOOKING_REQUEST_REJECTED',
  BOOKING_REQUEST_RETRACT: 'BOOKING_REQUEST_RETRACT',
  BOOKING_SCHEDULE_SET_CAR_DRIVER: 'BOOKING_SCHEDULE_SET_CAR_DRIVER',
  BOOKING_SCHEDULE_CHANGE_CAR_DRIVER: 'BOOKING_SCHEDULE_CHANGE_CAR_DRIVER'
};
